const i18nStub = {
    t: function () {
        return "Please set i18n instance"
    },
    te: function () {
        return false;
    }
}

let i18n = i18nStub;

/**
 * Sets the i18n instance to be used by the filters
 * @param newi18n
 */
function setFiltersi18n (newi18n) {
    i18n = newi18n;
}

export {i18n, setFiltersi18n}
